let isDev = false;
let config = {
    dev: {
        apiDomain: "https://devapi.koreanssam.com",
        imageDomain: 'https://imagedev.koreanssam.com',
        firebaseScretKey: 'f27e5d561348783dc50610b2aae7a8b9',
        record: {
            BucketName: 'koreanssam-record',
            BucketRegion: 'ap-northeast-2',
            AccessKey: 'QUtJQVZUVktMVE9ZSE9VRUdUVkI=',
            AccessSecretKey: 'YVhjcGV3ZnErVDV4d1l2TWxGM0R4U1V2d255QTlDdFJvSi80ZmNuVw==',
        },
        firebaseOption: {
            apiKey: "AIzaSyAlsYd_y_8CtUOTDd0SFGwZsGLieb-ys-o",
            authDomain: "peopleandtalk-392f3.firebaseapp.com",
            projectId: "peopleandtalk-392f3",
            storageBucket: "peopleandtalk-392f3.appspot.com",
            messagingSenderId: "796313796681",
            appId: "1:796313796681:web:614776f675da81ddd5bf98"
        },
        contentNoLevelNode: {
            1: [6],
            2: [9],
        }
    },
    prod: {
        apiDomain: 'https://api.koreanssam.com',
        imageDomain: `https://image.koreanssam.com`,
        firebaseScretKey: 'f27e5d561348783dc50610b2aae7a8b9',
        record: {
            BucketName: 'koreanssam-record',
            BucketRegion: 'ap-northeast-2',
            AccessKey: 'QUtJQVZUVktMVE9ZSE9VRUdUVkI=',
            AccessSecretKey: 'YVhjcGV3ZnErVDV4d1l2TWxGM0R4U1V2d255QTlDdFJvSi80ZmNuVw==',
        },
        firebaseOption: {
            apiKey: "AIzaSyAnR9JTs9VhGJpeX7-Vhm-GlgD6bOF_1jY",
            authDomain: "peopleandtalkproject.firebaseapp.com",
            projectId: "peopleandtalkproject",
            storageBucket: "peopleandtalkproject.appspot.com",
            messagingSenderId: "787333576887",
            appId: "1:787333576887:android:653601c6f765911a14f532"
        },
        contentNoLevelNode: {
            1: [37],
            2: [9],
        }
    }
}

function getConfig(key='apiDomain') {
    return isDev ? config.dev[key] : config.prod[key];
}

let apiDomain = getConfig('apiDomain')
let apiURL = `${getConfig('apiDomain')}/api/`;
let imageDomain = getConfig('imageDomain')
let firebaseOption = getConfig('firebaseOption')
let record = getConfig('record')
let contentNoLevelNode = getConfig('contentNoLevelNode')
// const apiDomain = "https://devapi.koreanssam.com/"; //개발서버
 //const apiDomain = "https://api.koreanssam.com/"; //실서버

//실서버 개발서버 변경 할 시 contentService.js 에서 noLevelNodeId 도 변경해주어야 합니다.

// const apiURL = `${apiDomain}/api/`;

export {apiURL, apiDomain, imageDomain, firebaseOption, contentNoLevelNode, record};
